import { IntlShape } from "react-intl";

import { FormErrors } from "@nens/ranalib";
import { capitalizeFirst } from "@nens/shared-utils";

import { getNameFromFileId } from "@/utils/get-name-from-file-id";
import { containsInvalidCharacters, getFirstInvalidCharacter } from "@/utils/invalid-characters";

type FileNameFormValues = {
  name: string;
};

export const validateFileName = (
  intl: IntlShape,
  type: string | undefined,
  existingFileIds: string[],
  values: FileNameFormValues
) => {
  const errors: FormErrors = {};

  const hasInvalidcharacter = containsInvalidCharacters(values.name);
  if (hasInvalidcharacter) {
    errors.name = intl.formatMessage(
      {
        id: "form.notallowed.character",
        defaultMessage: 'The "{character}" character is not allowed in a {type} name.',
      },
      {
        character: getFirstInvalidCharacter(values.name),
        type,
      }
    );
  }

  if (existingFileIds.map((id) => getNameFromFileId(id)).includes(values.name)) {
    errors.name = intl.formatMessage(
      {
        id: "form.exists.name",
        defaultMessage: "{type} with that name already exists in this directory",
      },
      {
        type: capitalizeFirst(type),
      }
    );
  }

  return errors;
};
